import { CALLOUT_BLOCK_SLUG, CALLOUT_VARIANTS } from '@/editors/callout';
import React from 'react';

import './styles.scss';

import type { Callout } from '@/payload-types';
import type { JSXConvertersFunction } from '@payloadcms/richtext-lexical/react';

export const RICH_TEXT_CLASS = 'fv-rich-text';

const WEB_URL = /^https?:\/\//;

const fieldOf = (value: unknown, field: 'mimeType' | 'url'): unknown =>
  typeof value === 'object' && value !== null && field in value ? Reflect.get(value, field) : null;

export const sharedConverters: JSXConvertersFunction = ({ defaultConverters }) => ({
  ...defaultConverters,
  blocks: {
    [CALLOUT_BLOCK_SLUG]: ({ node }: { node: { fields: Callout } }) => {
      const { content, variant } = node.fields;

      return (
        <aside className={`${RICH_TEXT_CLASS}__callout ${RICH_TEXT_CLASS}__callout--${variant}`}>
          <strong>{CALLOUT_VARIANTS.find((option) => option.value === variant)?.label}</strong>
          <p>{content}</p>
        </aside>
      );
    },
  },
  upload: (args) => {
    const mimeType = fieldOf(args.node.value, 'mimeType');
    const url = fieldOf(args.node.value, 'url');

    if (typeof url !== 'string' || !WEB_URL.test(url)) return null;

    if (typeof mimeType === 'string' && mimeType.startsWith('video/')) {
      return <video className={`${RICH_TEXT_CLASS}__video`} controls preload="metadata" src={url} />;
    }

    const fallback = defaultConverters.upload;

    return typeof fallback === 'function' ? fallback(args) : null;
  },
});
